import $ from 'jquery';

$(() => {
  $('.discount-code-link').on('click', (e) => {
    e.preventDefault;// eslint-disable-line
    $(e.target).siblings('.discount-panel').addClass('visible-content');
    $('.discount-code-link').addClass('disabled');
  });

  $('.discount-code-input').on('focusout input', function () {
    if (!$(this).val()) {
      $(this).parent().siblings('.discount-code-apply').attr('disabled', '');
      $(this).closest('.panel-section').addClass('invalid');
    } else {
      $(this).parent().siblings('.discount-code-apply').removeAttr('disabled');
      $(this).closest('.panel-section').removeClass('invalid');
    }
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/discount-code.js
 **/